import { StatusText } from '../../../../components/table/StatusText';
import type { JobPostingListItem } from '../applicantTypes';

/**
 * A job posting's status, ONE derivation for every surface that shows it — Applicants' postings and
 * their profile, Deliberate's postings and their deliberation page:
 *
 * - **Filled** — the posting ended and its item is held now, with no later posting for it (21 Oct 2026).
 * - **Inactive** — the posting ended otherwise (its tag was removed).
 * - **Completed** — an applicant on it is endorsed for appointment (Deliberate, 21 Oct 2026); it takes
 *   no new applicants, and reverts to Active the moment that endorsement is withdrawn.
 * - **Active** — open.
 *
 * Completed takes the neutral `inactive` tone: the word carries the meaning, and `pending` is refused
 * on an index surface.
 */
export function PostingStatusText({
  posting,
}: {
  posting: Pick<JobPostingListItem, 'isActive' | 'isCompleted' | 'isFilled'>;
}) {
  // FILLED — ended, and its item is held now: the word Vacancies already gives a filled item.
  if (!posting.isActive) return <StatusText tone="inactive">{posting.isFilled ? 'Filled' : 'Inactive'}</StatusText>;
  if (posting.isCompleted) return <StatusText tone="inactive">Completed</StatusText>;
  return <StatusText tone="active">Active</StatusText>;
}
